import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import InputGroup from '../../../../../components/global/InputGroup';
import { getAsset } from '../../../../../util/assets';
import Button from '../../../../../components/global/Button';
import Spinner from '../../../../../components/global/Spinner';
import ArrowRight from '../../../../../components/icons/ArrowRight';

const propTypes = {
  values: PropTypes.shape({
    email: PropTypes.string,
    password: PropTypes.string,
    phone_number: PropTypes.string,
    code: PropTypes.string,
  }).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  onLoginViaPhone: PropTypes.func,
};

const EmailPasswordForm = ({
  values,
  handleSubmit,
  handleChange,
  loading,
  onLoginViaPhone,
}) => {
  return (
    <Fragment>
      <h4 className="text-center mb-4">Sign in to access this gallery</h4>
      <form
        className="w-100 px-0 px-md-6 d-flex flex-column align-items-center"
        onSubmit={handleSubmit}
      >
        <InputGroup
          id="email"
          type="email"
          name="email"
          addon={<img alt="" src={getAsset('/shutterbug/icons/email.svg')} />}
          placeholder="Your email address"
          value={values.email}
          onChange={handleChange}
          wrapperClassName="w-100 mb-2"
        />
        <InputGroup
          id="password"
          type="password"
          name="password"
          addon={
            <img alt="" src={getAsset('/shutterbug/icons/password.svg')} />
          }
          placeholder="Password"
          value={values.password}
          onChange={handleChange}
          wrapperClassName="w-100 mb-2"
        />
        <Button
          type="submit"
          className="btn-block mt-2"
          disabled={loading || values.email === '' || values.password === ''}
        >
          {loading ? <Spinner light size="xs" /> : 'Continue'}
        </Button>
        <Button
          btnStyle="link"
          className="text-extra-bold mt-2"
          onClick={() => onLoginViaPhone()}
        >
          Login via phone
        </Button>
      </form>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4">
        No account?{' '}
        <Link
          to="/shutterbug/register"
          className="ml-0 ml-md-2 mt-1 mt-md-0 d-flex align-items-center text-primary text-extra-bold"
        >
          Register Here{' '}
          <ArrowRight color="#0d84fe" className="ml-1" size={15} />
        </Link>{' '}
      </div>
    </Fragment>
  );
};

EmailPasswordForm.propTypes = propTypes;

export default EmailPasswordForm;
